export default {
    /**
     * getToken     获取token
     * setToken     设置token
     * clearToken   清除token
     */
    getToken: () => {
        let token:any=sessionStorage.getItem('_TOKEN');
        return JSON.parse(token)
    },
    setToken (token?:string) {
        sessionStorage.setItem('_TOKEN', JSON.stringify(token))
    },
    clearToken () {
        sessionStorage.removeItem('_TOKEN')
    },
    /**
     * getUserId     获取userId
     * setUserId     设置userId
     * clearUserId   清除userId
     */
    getUserId: () => {
        let userId:any=sessionStorage.getItem('_USERID')
        return JSON.parse(userId)
    },
    setUserId (userId?:Number) {
        sessionStorage.setItem('_USERID', JSON.stringify(userId))
    },
    clearUserId () {
        sessionStorage.removeItem('_USERID')
    },
    /**
     * getUnitId     获取unitId
     * setUnitId     设置unitId
     * clearUnitId   清除unitId
     */
    getUnitId: () => {
        let unitId:any=sessionStorage.getItem('_UNITID')
        return JSON.parse(unitId)
    },
    setUnitId (unitId?:Number) {
        sessionStorage.setItem('_UNITID', JSON.stringify(unitId))
    },
    clearUnitId () {
        sessionStorage.removeItem('_UNITID')
    },
    /**
     * getAppTag     获取appTag
     * setAppTag     设置appTag
     * clearAppTag   清除appTag
     */
    getAppTag: () => {
        let appTag:any=sessionStorage.getItem('_APPTAG')
        return JSON.parse(appTag)
    },
    setAppTag (appTag?:Number) {
        sessionStorage.setItem('_APPTAG', JSON.stringify(appTag))
    },
    clearAppTag () {
        sessionStorage.removeItem('_APPTAG')
    },
}
